import { RootState } from "@store";
import { Me } from "@store/me/reducer";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

export const useMe = (): Me | undefined => {
  const me = useSelector((store: RootState) => store.me as Me | undefined);
  if (!me || !me.email?.value?.length || !me.email) return;
  return me;
};

const settingsSelector = () => {
  const selector = (state: RootState) => state.me.settings;
  return selector;
};

export const useSettingsNames = () => {
  const selector = settingsSelector();
  const reselect = createSelector(selector, (settings) =>
    settings.map((s) => s.name)
  );
  const settings = useSelector(reselect);
  // const me = useSelector((store: RootState) => store.me as Me | undefined);
  // const settings = me?.settings.map((item, i) => item.name);
  return settings || [];
};

export const useSettings = () => {
  const selector = settingsSelector();
  // const me = useSelector((store: RootState) => store.me as Me | undefined);
  // const settings = me?.settings;
  const reselect = createSelector(selector, (settings) => settings);
  const settings = useSelector(reselect);
  return settings || [];
};
